import { useEffect, useState } from "react";
import { CheckCircle2, XCircle, History } from "lucide-react";
import { adminApi } from "@/lib/api";
import { fmtMoney } from "@/components/status";

export default function SapHistory({ refreshKey }) {
  const [rows, setRows] = useState([]);
  useEffect(() => { adminApi.sapHistory(20).then(setRows).catch(() => setRows([])); }, [refreshKey]);
  return (
    <div data-testid="sap-history" className="rounded-2xl border border-slate-200 bg-white p-5">
      <div className="mb-3 flex items-center gap-2"><History className="h-5 w-5 text-[#28282E]" /><h2 className="font-serif text-lg font-semibold text-[#28282E]">SAP send history</h2></div>
      {rows.length === 0 ? <p className="py-4 text-center text-sm text-[#28282E]/55">Nothing has been sent to SAP yet.</p> : (
        <table className="w-full text-sm">
          <thead><tr className="text-left text-[11px] font-semibold uppercase tracking-wide text-[#28282E]/55"><th className="pb-2">Sent</th><th className="pb-2">SAP order</th><th className="pb-2">DC date</th><th className="pb-2">Into store</th><th className="pb-2">PO ref</th><th className="pb-2 text-right">Lines</th><th className="pb-2 text-right">Cartons</th><th className="pb-2 text-right">PO total</th><th className="pb-2">By</th><th className="pb-2">Status</th></tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} data-testid={`sap-history-row-${r.id}`} className="border-t border-slate-100">
                <td className="py-2 text-xs">{String(r.sent_at).slice(0, 16).replace("T", " ")}</td>
                <td className="py-2 font-mono font-semibold">{r.sap_sales_order || "—"}</td>
                <td className="py-2">{r.into_dc_date}</td>
                <td className="py-2">{r.into_store_date}</td>
                <td className="py-2 text-xs">{r.po_number}</td>
                <td className="py-2 text-right">{r.item_count}</td>
                <td className="py-2 text-right font-semibold">{Math.round(r.total_cartons)}</td>
                <td className="py-2 text-right">{fmtMoney(r.grand_total)}</td>
                <td className="py-2 text-xs">{r.sent_by || "admin"}{r.is_resend ? " · re-send" : ""}</td>
                <td className="py-2">{r.status === "sent" ? <span className="inline-flex items-center gap-1 text-xs font-semibold text-emerald-700"><CheckCircle2 className="h-3.5 w-3.5" /> Sent</span> : <span className="inline-flex items-center gap-1 text-xs font-semibold text-red-700" title={r.error}><XCircle className="h-3.5 w-3.5" /> Failed</span>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
